module.exports = __webpack_public_path__ + "static/media/arrow.cab8cd1a.svg";